<template>
    <div class="field">
        <z-title title="场地设置" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac fjb">
            <div class="flex-n fac">
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        placeholder="输入号码"
                        title="输入号码"
                        prefix-icon="el-icon-search"
                        maxlength="8"
                        clearable
                        v-model="houseNo">
                </el-input>
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        maxlength="16"
                        placeholder="输入名称"
                        title="输入名称"
                        clearable
                        prefix-icon="el-icon-search"
                        v-model="houseName">
                </el-input>
            </div>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="searchField">查询</el-button>
                <el-button type="primary" class="ele-btn2" @click="addField">新增</el-button>
            </div>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="fieldData"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="orderIndex"
                        label="场地排序"
                        width="100">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="houseNo"
                        label="号 码"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="houseName"
                        label="名 称"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="houseTypeName"
                        label="类 型"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="houseLocation"
                        label="位 置"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="状 态"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.houseState=='0'?'启用':'停用'}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备 注"
                        min-width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="180"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small mr-10" @click="editField(scope.row.id)">编辑</el-button>
                           <template v-if="scope.row.houseState=='1'">
                               <el-popconfirm
                               title="确定启用场地吗？（启用场地将能正常使用）"
                               @confirm="openField(scope.row.id)"
                               >
                               <el-button  slot="reference" type="primary" class="ele-btn-small mr-10">启用</el-button>
                               </el-popconfirm>
                           </template>
                            <template v-else>
                            <el-popconfirm
                                    title="确定停用场地吗？（停用的场地将不能再被选择）"
                                    @confirm="stopField(scope.row.id)"
                            >
                            <el-button  slot="reference" type="primary" class="ele-btn-small mr-10">停用</el-button>
                            </el-popconfirm>
                            </template>

                            <el-popconfirm
                                    title="确定删除场地吗？（删除场地会删除关联数据，若不想移除，请使用停用功能）"
                                    @confirm="delField(scope.row.id)"
                            >
                            <el-button  slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--新增场地-->
        <el-dialog :visible.sync="showedit"
                   :close-on-click-modal="false"
                  class="ele-toast">
            <div slot="title">
                <z-title :title="editstate+'场地'"></z-title>
            </div>
            <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="rulefrom">
                <el-form-item label="号 码" prop="houseNo" label-width="80px">
                    <el-input maxlength="8" v-model="dataForm.houseNo" placeholder="请输入场地号码"></el-input>
                </el-form-item>
                <el-form-item label="名 称" prop="houseName" label-width="80px">
                    <el-input maxlength="16" v-model="dataForm.houseName" placeholder="请输入场地名称"></el-input>
                </el-form-item>
                <el-form-item label="场地类型" prop="houseTypeId" label-width="80px">
                    <house-type v-model="dataForm.houseTypeId" placeholder="请选择" style="width: 100%"></house-type>
                </el-form-item>
                <el-form-item label="状 态" prop="houseState" label-width="80px">
                    <el-radio-group v-model="dataForm.houseState">
                        <el-radio label="0">启用</el-radio>
                        <el-radio label="1">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="场地排序" prop="orderIndex" label-width="80px">
                    <el-input maxlength="16" class="w-120" style="text-align: left;!important;" v-model="dataForm.orderIndex" placeholder="请输入场地排序" v-number></el-input>
                </el-form-item>
                <el-form-item label="位 置" prop="houseLocation" label-width="80px">
                    <el-input maxlength="32" v-model="dataForm.houseLocation" placeholder="请输入场地位置"></el-input>
                </el-form-item>
                <el-form-item label="备 注" prop="remark" label-width="80px">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
                    <el-button @click="showedit = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import ElFormItem from "element-ui/packages/form/src/form-item";
    import HouseType from "../../components/data/houseType";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            HouseType,
            ElFormItem,
            ZTitle
        },
        name: "field",
        data() {
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                dataForm: {
                    houseState:'0'
                },
                editstate: '新增',
                showedit: false,

                fieldData:[],

                houseNo: '',
                houseName: '',
                id:'',


                rules: {
                    houseNo: [{required: true, message: '场地号码不能为空', trigger: 'blur'}],
                    houseName: [{required: true, message: '场地名称不能为空', trigger: 'blur'}],
                    houseTypeId:[{required: true, message: '场地类型不能为空', trigger: 'change'}],
                },

            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.gethouseList();
        },
        watch:{
            showedit(newval,oldval){
                if(!newval){
                    this.$refs.ruleForm.resetFields();
                }
            }
        },
        methods: {
            //查询场地信息
            gethouseList() {
                this.loading=true;
                this.$axios.post('/house/houseList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "houseNo": this.houseNo,
                    "houseName": this.houseName,
                    "pageSize": this.pageSize,
                    "currentPage": this.currentPage
                }).then(res => {
                    console.log('场地信息', res)
                    this.fieldData = res.data.list;
                    this.total = res.data.total;
                    this.loading=false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading=false;
                })
            },
            //搜索
            searchField(){
                this.currentPage=1;
                this.gethouseList();
            },
            //新增
            addField() {
                this.showedit = true;
                this.editstate = '新增'
            },
            //编辑
            editField(id) {
                console.log('编辑',id)
                this.id=id;
                this.showedit = true;
                this.editstate = '编辑';
                this.$axios.get('/house/houseById/'+id).then(res=>{
                    console.log(res)
                    this.dataForm=res.data;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //启用
            openField(id){
                this.manageField(id,0);
            },
            //停用
            stopField(id){
                this.manageField(id,1);
            },
            manageField(id,houseState){
                this.$axios.post('/house/houseUpdate',{
                    "storeId": this.$root.getStorage('storeId'),
                    "id":id,
                    "houseState": houseState,
                }).then(res=>{
                    this.$message.success((houseState=='0'?'启用':'停用')+'场地成功！');
                    this.gethouseList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //删除
            delField(id){
                console.log(id)
                this.$axios.post('/house/houseDeleteByIds',id).then(res=>{
                    this.$message.success('删除场地成功！');
                    this.gethouseList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })

            },
            //添加提交
            addSubmit(){
                let {houseNo,houseName,houseTypeId,houseLocation,houseState,orderIndex,remark}=this.dataForm;
                this.$axios.post('/house/houseAdd',{
                    "storeId": this.$root.getStorage('storeId'),
                    "houseNo": houseNo,
                    "houseName": houseName,
                    "houseTypeId": houseTypeId,
                    "houseLocation":houseLocation,
                    "orderIndex":orderIndex,
                    "houseState":houseState,
                    "remark": remark
                }).then(res=>{
                    this.currentPage = 1;
                    this.gethouseList();
                    this.$message.success('新增场地成功！');
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit(){
                let {houseNo,houseName,houseTypeId,houseLocation,houseState,orderIndex,remark}=this.dataForm;
                this.$axios.post('/house/houseUpdate',{
                    "storeId": this.$root.getStorage('storeId'),
                    "id":this.id,
                    "houseNo": houseNo,
                    "houseName": houseName,
                    "houseTypeId": houseTypeId,
                    "houseLocation":houseLocation,
                    "houseState":houseState,
                    "orderIndex":orderIndex,
                    "remark": remark
                }).then(res=>{
                    this.$message.success('编辑场地成功！');
                    this.gethouseList();
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.editstate == '新增'){
                            this.addSubmit();
                        }else{
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.gethouseList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.gethouseList();
                console.log(`当前页: ${val}`);
            },
        },
    }
</script>


<style scoped lang="scss">
    .field {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
    }
</style>